import React from 'react';
import { Icon } from '@shakkerai/components';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { translate } from '@shakkerai/util-i18n';
import { setTempState } from '@starflow/app/store';
import { useModelFavorite } from '../../../hooks/data';
import { communityUrl } from '../../../constants';
import iconModelUsing from '../../../assets/model_using_pic.svg';
import { request } from '@shakkerai/services';
import { notifyWarn } from '@shakkerai/pro-components';
import { enterWorkflowMode } from '../../../../workflow/helpers/helpers';

const FlowCard = React.memo(({ data, onUpdate, showAuthorInfo = true, ratio, cols, from }) => {
  const { favorited, favoriteModel } = useModelFavorite(data);
  const using = false; // 保留该功能 后期扩展
  const handleToggleFavorite = (event) => {
    favoriteModel(favorited ? 0 : 1, 'card');
    onUpdate?.(data, { isLike: favorited ? 0 : 1 });

    event.stopPropagation();
  };

  const enterWorkflowState = async (event) => {
    if (!data.uuid) {
      notifyWarn(translate('feed_error'));
      console.log('数据异常', data);
    }
    try {
      const result = await request(`/api/www/img/tool/style/model/baseDetail/${data.uuid}`);
      if (result.code === 0) {
        enterWorkflowMode(result.data);
        setTempState({
          exclusiveWindow: null,
        });
      }
    } catch (err) {
      notifyWarn(translate('feed_error'));
      console.log('api error', err);
    }
    event.stopPropagation();
  };

  const handleViewQuickApp = () => {
    window.open(`${communityUrl}/modelinfo/${data.modelUuid}`, '__blank');
  };
  return (
    <div style={{ width: `${100 / cols}%`, aspectRatio: ratio }} className="pr-4 pb-4 max-h-[254px]">
      <div className="group relative overflow-hidden bg-[#f4f6f8] rounded flex-shrink-0 h-full">
        {/* <div className="absolute top-[10px] left-[10px] z-[5] flex items-center ">
          <div className="flex items-center h-5 mr-1 px-3 bg-black/40 rounded">
            <span className="text-white text-xs font-bold">{translate('flow_quick_apply_icon')}</span>
          </div>
        </div> */}
        <div
          className={`absolute inset-0 z-[5] ${
            using ? 'border-2 border-primary' : 'border border-black/10'
          } rounded pointer-events-none`}
        />
        <img
          onClick={enterWorkflowState}
          style={{ height: '75%' }}
          src={convert2CompressedUrl(data.imageUrl, 350)}
          className="block w-full h-3/4 object-cover cursor-pointer group-hover:scale-110 transition duration-500"
        />
        {data.unsupported && (
          <div
            style={{ height: '60%' }}
            className="absolute inset-0 z-2 bg-black/80 flex flex-col items-center justify-center"
          >
            <Icon className="icon-zanbukeyong" color="#fff" fontSize={24} />
            <span className="text-white text-xs">{translate('model_online_unsupported')}</span>
          </div>
        )}
        <div className="h-[61px] bg-white" />
        <div className="absolute bottom-0 left-0 z-[2] w-full p-3 bg-white translate-y-[32px] group-hover:translate-y-0 transition duration-500">
          <h4 className="flex items-start">
            {using && <img src={iconModelUsing} className="w-[16px] h-[16px] mr-1" />}
            <span
              style={{ color: '#2d2d2d', fontSize: '12px' }}
              className="flex-1 leading-[17px] font-bold text-ellipsis whitespace-nowrap overflow-hidden group-hover:max-h-[34px] group-hover:whitespace-pre-line group-hover:overflow-hidden"
            >
              {data.name}
            </span>
          </h4>
          {showAuthorInfo ? (
            <div className="flex items-center mt-[10px]">
              <img src={convert2CompressedUrl(data.userAvatar, 36)} className="w-[18px] h-[18px] rounded-full" />
              <span className="flex-1 mr-4 ml-1 text-[11px] text-[#7f7f7f] text-ellipsis whitespace-nowrap overflow-hidden">
                {data.userName}
              </span>
              <Icon className="shk-danchuang-yunhangliang" fontSize={12} color="#7f7f7f" />
              <span className="text-[11px] text-[#7F7F7F] ml-[4px]">{data.runCount}</span>
            </div>
          ) : (
            <h5 className="w-[150px] text-xs leading-[18px] text-[#7f7f7f] text-ellipsis whitespace-nowrap overflow-hidden">
              {data.versionName}
            </h5>
          )}
          <div className="flex mt-2 opacity-0 group-hover:opacity-100 transition duration-500 text-xs text-[#2d2d2d]">
            <button
              onClick={handleToggleFavorite}
              className="flex items-center justify-center w-8 h-[26px] bg-[#EDF1F5] rounded"
            >
              <Icon
                color={favorited ? '#FFC351' : '#2d2d2d'}
                className={`${favorited ? 'icon-filled_star' : 'icon-border_star'} -translate-y-px`}
                fontSize={14}
              />
            </button>
            <button
              onClick={handleViewQuickApp}
              className="flex items-center justify-center w-8 h-[26px] ml-2 bg-[#EDF1F5] rounded"
            >
              <Icon className="icon-External_Link" fontSize={14} color="#2d2d2d" />
            </button>
            <button
              className="flex items-center justify-center w-20 h-[26px] ml-2 bg-[#EDF1F5] rounded"
              onClick={enterWorkflowState}
            >
              <Icon className="shk-danchuang-yunhangliang" fontSize={14} color="#2d2d2d" />
              <span style={{ fontSize: '12px' }} className="translate-y-px ml-1 pb-[1px] text-xs text-[#2d2d2d]">
                {translate('use_btn1')}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default FlowCard;
